"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Play = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  className: "svg-inline--fa fa-play-circle fa-w-16",
  "data-icon": "play-circle",
  "data-prefix": "fad",
  viewBox: "0 0 512 512"
}, /*#__PURE__*/_react.default.createElement("g", {
  className: "fa-group"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.black,
  d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z",
  className: "fa-secondary",
  opacity: "0.4"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.black,
  d: "M371.7 280l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z",
  className: "fa-primary"
})));

var _default = Play;
exports.default = _default;